import QueryManager from "../../../utils/QueryManager";
import {getLocalStorageKey} from "../../../settings";

const curLocalStorageKey = getLocalStorageKey("rates_filters");
let rateFiltersSerializableDates:string[] = []
let rateFiltersSerializableJoins:string[] = []

class RatesFiltersManagerClass extends QueryManager {}

const RatesFiltersManager = new RatesFiltersManagerClass({
    serializable: {dates: rateFiltersSerializableDates, joins: rateFiltersSerializableJoins},
    localStorageKey: curLocalStorageKey,
});

export default RatesFiltersManager;